import * as crypto from "crypto";

export const generateHMAC = (secret: string, value: string): string => {
  return crypto.createHmac("sha256", secret).update(value).digest("hex");
};
